import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from '../Response';

import Types from '../../../actions/Types';

import Story from '../../../../domain/entities/response/Story';
import PaginatedResult from '../../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.ResetWriterCurrentUser:
      return {};
    case Types.IndexResponseStoriesSuccess: {
      const result = action.payload as PaginatedResult<Story>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
